import { Checkbox, CheckboxStates } from "@/components/ui/checkbox";
import { useVistassistantMail } from "@/contexts/VistassistantMailContext";
import Email, { MailsListId } from "@/domain/entities/emails/Email";
import { cn } from "@/lib/utils";
import { CheckedState } from "@radix-ui/react-checkbox";
import { ReactNode, useEffect, useState } from "react";
import MailViewToggle, { MailView } from "../toggles/MailViewToggle";
import { MailMassAction } from "./MailAction";

interface EmailViewHeaderProps {
    selectedMails: Email[];
    mailsListFlattened: Email[];
    onSelectAllChange: (checked: boolean) => void;
    view: MailView;
    onViewChange: (view: MailView) => void;
    setSelectedMails: (selectedMails: Email[]) => void;
    title?: ReactNode;
    hideSideListMode?: boolean;
    listId: MailsListId;
}

const EmailViewHeader = ({
    selectedMails,
    mailsListFlattened,
    onSelectAllChange,
    view,
    onViewChange,
    title,
    setSelectedMails,
    hideSideListMode,
    listId,
}: EmailViewHeaderProps) => {
    const { isVistassistantResult } = useVistassistantMail();
    const [checkState, setCheckState] = useState<CheckedState>(
        Boolean(mailsListFlattened) &&
            selectedMails.length === mailsListFlattened?.length,
    );

    useEffect(() => {
        if (!mailsListFlattened) return;

        if (mailsListFlattened.length === selectedMails.length) {
            setCheckState(CheckboxStates.CHECKED);
        } else if (selectedMails.length !== 0) {
            setCheckState(CheckboxStates.INDETERMINATE);
        } else {
            setCheckState(CheckboxStates.UNCHECKED);
        }
    }, [selectedMails, mailsListFlattened]);

    return (
        <div
            className={cn(
                "relative py-2 pl-2 pr-4",
                isVistassistantResult && "pt-0",
            )}
        >
            {title}
            <div className="flex items-center justify-between">
                <div className="flex items-center justify-center gap-3">
                    <Checkbox
                        checked={checkState}
                        disabled={mailsListFlattened.length === 0}
                        onCheckedChange={() => {
                            if (mailsListFlattened.length === 0) {
                                return;
                            }

                            setCheckState(!checkState);
                            onSelectAllChange(!checkState);
                        }}
                    />
                    {checkState && mailsListFlattened.length > 0 && (
                        <MailMassAction
                            className="ml-2"
                            listId={listId}
                            selectedMails={selectedMails}
                            setSelectedMails={setSelectedMails}
                        />
                    )}
                </div>

                <MailViewToggle
                    hideSideListMode={hideSideListMode}
                    onChange={onViewChange}
                    view={view}
                />
            </div>
        </div>
    );
};

export default EmailViewHeader;
